// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VDWT","buttons":"styles_buttons__1Btv3"};